import React, { useState } from "react";
import "./Navbar.css";
import { Link, NavLink } from "react-router-dom";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);

  const handleLinkClick = () => {
    setMenuOpen(false);
    setCompanyOpen(false);
  };

  return (
    <nav className="lux-navbar">
      <div className="lux-nav-container">

        {/* LOGO */}
        <Link
          to="/"
          className="lux-logo"
          onClick={handleLinkClick}
        >
          <img
            src="/img/finllogo.png"
            alt="SmartVizX"
          />
        </Link>

        {/* HAMBURGER */}
        <button
          className={`lux-hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* MENU */}
        <ul className={`lux-menu ${menuOpen ? "open" : ""}`}>

          <li onClick={handleLinkClick}>
            <Link to="/products">Our Work</Link>
          </li>

          <li
            className={`has-dropdown ${companyOpen ? "open" : ""}`}
            onClick={() => setCompanyOpen(!companyOpen)}
          >
            <span>Company</span>

            <ul
              className="lux-dropdown"
              onClick={handleLinkClick}
            >
              <li>
                <Link to="/about">Team</Link>
              </li>

              <li>
                <Link to="/press">Press</Link>
              </li>

              <li>
                <Link to="/career">Careers</Link>
              </li>

              <li>
                <Link to="/clients">Clients</Link>
              </li>
            </ul>
          </li>

          <li onClick={handleLinkClick}>
            <a
              href="https://trezi.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Product
            </a>
          </li>

          <li onClick={handleLinkClick}>
            <Link to="/blog">Blog</Link>
          </li>

          <li onClick={handleLinkClick}>
            <NavLink
              to="/contact"
              end
              className={({ isActive }) =>
                isActive
                  ? "lux-contact-btn active"
                  : "lux-contact-btn"
              }
            >
              Contact
            </NavLink>
          </li>

        </ul>
      </div>
    </nav>
  );
}

export default Navbar;